import { WrapWithPrismicPreviewProvider } from './prismicPreview/WrapWithPrismicPreviewProvider';
import './src/design/typography/fonts/font-face-aeonik.css';
import './src/design/utils/reset.css';

export const wrapRootElement = WrapWithPrismicPreviewProvider;
